import { render, staticRenderFns } from "./CommissionCalculation.vue?vue&type=template&id=090debc0&"
import script from "./CommissionCalculation.vue?vue&type=script&lang=js&"
export * from "./CommissionCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports